//Fetch Counts Data
export const FETCH_INTERVIEW_COUNT_REQUEST = "FETCH_INTERVIEW_COUNT_REQUEST";
export const FETCH_INTERVIEW_COUNT_SUCCESS = "FETCH_INTERVIEW_COUNT_SUCCESS";
export const FETCH_INTERVIEW_COUNT_FAILURE = "FETCH_INTERVIEW_COUNT_FAILURE";

//Fetch Table Data
export const FETCH_INTERVIEW_LISTING_REQUEST =
  "FETCH_INTERVIEW_LISTING_REQUEST";
export const FETCH_INTERVIEW_LISTING_SUCCESS =
  "FETCH_INTERVIEW_LISTING_SUCCESS";
export const FETCH_INTERVIEW_LISTING_FAILURE =
  "FETCH_INTERVIEW_LISTING_FAILURE";

//Cancel Interviews
export const DELETE_INTERVIEWS_REQUEST = "DELETE_INTERVIEWS_REQUEST";
export const DELETE_INTERVIEWS_SUCCESS = "DELETE_INTERVIEWS_SUCCESS";
export const DELETE_INTERVIEWS_FAILURE = "DELETE_INTERVIEWS_FAILURE";

//Custom View
export const CREATE_INTERVIEW_CUSTOM_VIEW = "CREATE_INTERVIEW_CUSTOM_VIEW";
export const CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS =
  "CREATE_INTERVIEW_CUSTOM_VIEW_SUCCESS";
export const CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE =
  "CREATE_INTERVIEW_CUSTOM_VIEW_FAILURE";

export const FETCH_INTERVIEW_CUSTOM_VIEW = "FETCH_INTERVIEW_CUSTOM_VIEW";
export const FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS =
  "FETCH_INTERVIEW_CUSTOM_VIEW_SUCCESS";
export const FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE =
  "FETCH_INTERVIEW_CUSTOM_VIEW_FAILURE";
export const RESET_INTERVIEW_CUSTOM_VIEW = "RESET_INTERVIEW_CUSTOM_VIEW";

export const SELECT_INTERVIEW_CUSTOM_VIEW = "SELECT_INTERVIEW_CUSTOM_VIEW";
export const SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS =
  "SELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS";
export const SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE =
  "SELECT_INTERVIEW_CUSTOM_VIEW_FAILURE";

export const DELETE_INTERVIEW_CUSTOM_VIEW = "DELETE_INTERVIEW_CUSTOM_VIEW";
export const DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS =
  "DELETE_INTERVIEW_CUSTOM_VIEW_SUCCESS";
export const DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE =
  "DELETE_INTERVIEW_CUSTOM_VIEW_FAILURE";

export const FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID =
  "FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID";
export const FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS =
  "FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE =
  "FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE";

export const EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID =
  "EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID";
export const EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS =
  "EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE =
  "EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID_FAILURE";

export const UNSELECT_INTERVIEW_CUSTOM_VIEW = "UNSELECT_INTERVIEW_CUSTOM_VIEW";
export const UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS =
  "UNSELECT_INTERVIEW_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE =
  "UNSELECT_INTERVIEW_CUSTOM_VIEW_FAILURE";

export const SET_INTERVIEW_DEFAULT_CUSTOM_VIEW =
  "SET_INTERVIEW_DEFAULT_CUSTOM_VIEW";
export const DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW =
  "DELETE_INTERVIEW_DEFAULT_CUSTOM_VIEW";

export const CANCEL_INTERVIEW_REQUEST = "CANCEL_INTERVIEW_REQUEST";
export const CANCEL_INTERVIEW_SUCCESS = "CANCEL_INTERVIEW_SUCCESS";
export const CANCEL_INTERVIEW_FAILURE = "CANCEL_INTERVIEW_FAILURE";

export const ADD_INTERVIEW_LOGS_REQUEST = "ADD_INTERVIEW_LOGS_REQUEST";
export const ADD_INTERVIEW_LOGS_SUCCESS = "ADD_INTERVIEW_LOGS_SUCCESS";
export const ADD_INTERVIEW_LOGS_FAILURE = "ADD_INTERVIEW_LOGS_FAILURE";

export const COMPLETE_INTERVIEW_REQUEST = "COMPLETE_INTERVIEW_REQUEST";
export const COMPLETE_INTERVIEW_SUCCESS = "COMPLETE_INTERVIEW_SUCCESS";
export const COMPLETE_INTERVIEW_FAILURE = "COMPLETE_INTERVIEW_FAILURE";

export const CREATE_INTERVIEW_REQUEST = "CREATE_INTERVIEW_REQUEST";
export const CREATE_INTERVIEW_SUCCESS = "CREATE_INTERVIEW_SUCCESS";
export const CREATE_INTERVIEW_FAILURE = "CREATE_INTERVIEW_FAILURE";

export const TRAIN_CREATE_INTERVIEW_REQUEST = "TRAIN_CREATE_INTERVIEW_REQUEST";
export const TRAIN_CREATE_INTERVIEW_SUCCESS = "TRAIN_CREATE_INTERVIEW_SUCCESS";
export const TRAIN_CREATE_INTERVIEW_FAILURE = "TRAIN_CREATE_INTERVIEW_FAILURE";

export const RESCHEDULE_INTERVIEW_REQUEST = "RESCHEDULE_INTERVIEW_REQUEST";
export const RESCHEDULE_INTERVIEW_SUCCESS = "RESCHEDULE_INTERVIEW_SUCCESS";
export const RESCHEDULE_INTERVIEW_FAILURE = "RESCHEDULE_INTERVIEW_FAILURE";

export const TRAIN_CANCEL_INTERVIEW_REQUEST = "TRAIN_CANCEL_INTERVIEW_REQUEST";
export const TRAIN_CANCEL_INTERVIEW_SUCCESS = "TRAIN_CANCEL_INTERVIEW_SUCCESS";
export const TRAIN_CANCEL_INTERVIEW_FAILURE = "TRAIN_CANCEL_INTERVIEW_FAILURE";

export const TRAIN_RESCHEDULE_INTERVIEW_REQUEST =
  "TRAIN_RESCHEDULE_INTERVIEW_REQUEST";
export const TRAIN_RESCHEDULE_INTERVIEW_SUCCESS =
  "TRAIN_RESCHEDULE_INTERVIEW_SUCCESS";
export const TRAIN_RESCHEDULE_INTERVIEW_FAILURE =
  "TRAIN_RESCHEDULE_INTERVIEW_FAILURE";

export const UPLOAD_INTERVIEW_ATTACHMENT_REQUEST =
  "UPLOAD_INTERVIEW_ATTACHMENT_REQUEST";
export const UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS =
  "UPLOAD_INTERVIEW_ATTACHMENT_SUCCESS";
export const UPLOAD_INTERVIEW_ATTACHMENT_FAILURE =
  "UPLOAD_INTERVIEW_ATTACHMENT_FAILURE";

export const FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST =
  "FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST";
export const FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS =
  "FETCH_INTERVIEW_BY_MULTI_IDS_SUCCESS";
export const FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE =
  "FETCH_INTERVIEW_BY_MULTI_IDS_FAILURE";
